import { CSSProperties } from 'react';

type Orders = {
  _id: string;
  address?: {
    city?: string;
    district?: string;
    id?: string;
    location?: {
      latitude?: number | string;
      latitudeDelta?: number;
      longitude?: number | string;
      longitudeDelta?: number;
    };
    orderType?: string;
    selected?: boolean;
    shopId?: string;
    street?: string;
    street2?: string;
    streetNumber?: string;
    instruction?: string;
    subLocality?: string;
    region?: string;
    country?: string;
    countryCode?: string;
    state?: string;
    postalCode?: string | number;
    zipcode?: string;
    deliveryPrice?: number;
    pricing?: {
      perKm?: {
        fees?: number;
        from?: number;
      };
      steps?: {
        fees?: number;
        km?: number;
      }[];
    };
  };
  canal?: string;
  cancellation?: {
    cancelReason?: string;
    canceledBy?: string;
    chargeId?: string;
  };
  chargeId?: string;
  commande?: {
    [commandeId: string]: {
      boughtPrice?: number;
      categories?: string;
      description?: string;
      disabled?: boolean;
      disabledDelivery?: boolean;
      key?: string;
      name?: string;
      nb?: number;
      position?: number;
      preparationTime?: string | number;
      price?: number;
      productKey?: string;
      sectionKey?: string | number;
      sectionName?: string;
      shopId?: string;
      unitPrice?: number;
      items?: {
        categoryId?: string;
        categoryKey?: string;
        categoryName?: string;
        categoryPosition?: number;
        categoryType?: string;
        options?: {
          [optionId: string]: {
            key?: string;
            label?: string;
            name?: string;
            position?: number;
            price?: number;
            ref?: string;
            subcategories?: string;
            value?: number;
            nb?: number;
            productKey?: string;
            dealName?: string;
            dealRef?: string;
            isProduct?: boolean;
            lineLabel?: string;
            option_list_id?: string;
            pricingEffect?: string;
            pricingValue?: string;
            productName?: string;
            product_id?: string;
            tags?: Array<string>;
            default?: boolean;
          };
        };
        categoryMultiple?: boolean;
      }[];
      image?: string;
      instruction?: string;
      image64?: string;
      height?: number;
      logo?: string;
      width?: number;
      ref?: string;
      stock?: number;
      disabledCC?: boolean;
      disabledCS?: boolean;
      unit?: string;
      volume?: string;
      sales?: {
        nb?: number;
        revenue?: number;
        billingId?: {
          date?: string;
          nb?: number;
          revenue?: number;
        };
      };
      imageIds?: Array<string>;
      hidden?: boolean;
    };
  };
  companyId?: string;
  date?: string;
  dateCompleted?: string;
  dateSent?: string;
  datePreparationEnded: string;
  estimatedDeliveryDate?: string;
  expectedDropoffDate?: string;
  datePreparationStarted?: string;
  dateSentToFleet?: string;
  delivery?: {
    date?: string;
    distance?: number;
    fee?: number;
    useFreelance?: boolean;
    freelance?: boolean;
    searchDriver?: boolean;
  };
  email?: string;
  firstName?: string;
  hasBeenDestocked?: boolean;
  id?: string;
  idDep?: string;
  isSchedule?: boolean;
  lastName?: string;
  managementFee?: number;
  numero?: string;
  orderNumber?: number;
  orderType?: string;
  paymentType?: string;
  shop?: {
    address?: {
      city?: string;
      district?: string;
      id?: string;
      location?: {
        latitude?: number | string;
        latitudeDelta?: number;
        longitude?: number | string;
        longitudeDelta?: number;
      };
      orderType?: string;
      selected?: boolean;
      shopId?: string;
      street?: string;
      street2?: string;
      streetNumber?: string;
      instruction?: string;
      subLocality?: string;
      region?: string;
      country?: string;
      countryCode?: string;
      state?: string;
      postalCode?: string | number;
      zipcode?: string;
      deliveryPrice?: number;
      pricing?: {
        perKm?: {
          fees?: number;
          from?: number;
        };
        steps?: {
          fees?: number;
          km?: number;
        }[];
      };
    };
    name?: string;
    support?: {
      email?: string;
      number?: string;
      fromEmail?: boolean;
    };
  };
  shopId?: string;
  status?: string;
  timezone?: string;
  totalPriceOrder?: number;
  totalProductPriceOrder?: number;
  userCancelServicePrice?: number;
  userNameDep?: string;
  userServicePrice?: number;
  fleet?: boolean;
  preparationTime?: number;
  shopLock?: boolean;
  stripeCustomerId?: string;
  driverLock?: boolean;
  numeroDep?: string;
  promotion?: {
    count?: number;
    date?: string;
    expired?: boolean;
    isGeneralData?: boolean;
    limit?: number;
    nbAdded?: number;
    nbUsed?: number;
    orderTypes?: Array<string>;
    promoCode?: string;
    promoPath?: string;
    ref?: string;
    shopId?: string;
    type?: string | number;
    canals?: Array<string>;
  };
  hubriseOrderId?: string;
  userLastNameDep?: string;
  distance?: string;
  stuart?: {
    enabled?: boolean;
    jobId?: number;
    pickupAt?: string;
    pricing?: {
      currency?: string;
      price_tax_excluded?: number;
      price_tax_included?: number;
      tax_amount?: number;
      tax_percentage?: number;
    };
  };
  tableNb?: string;
  customerLock?: boolean;
  hubriseId?: string;
  searchDriver?: boolean;
};

type Shops = {
  _id: string;
  address?: {
    city?: string;
    district?: string;
    id?: string;
    location?: {
      latitude?: number | string;
      latitudeDelta?: number;
      longitude?: number | string;
      longitudeDelta?: number;
    };
    orderType?: string;
    selected?: boolean;
    shopId?: string;
    street?: string;
    street2?: string;
    streetNumber?: string;
    instruction?: string;
    subLocality?: string;
    region?: string;
    country?: string;
    countryCode?: string;
    state?: string;
    postalCode?: string | number;
    zipcode?: string;
    deliveryPrice?: number;
    pricing?: {
      perKm?: {
        fees?: number;
        from?: number;
      };
      steps?: {
        fees?: number;
        km?: number;
      }[];
    };
  };
  admins?: {
    [userId: string]: string;
  };
  allowFirstOrderPromo?: boolean;
  categories?: {
    [categoryId: string]: {
      items?: {
        [itemId: string]: {
          key?: string;
          name?: string;
          position?: number;
          price?: number;
          ref?: string;
          subcategories?: string;
          productKey?: string;
          default?: boolean;
          option_list_id?: string;
          dealName?: string;
          dealRef?: string;
          isProduct?: boolean;
          lineLabel?: string;
          pricingEffect?: string;
          pricingValue?: string;
          productName?: string;
          product_id?: string;
          tags?: Array<string>;
        };
      };
      key?: string;
      multiple?: boolean;
      name?: string;
      position?: number;
      type?: string;
      max?: number | string;
    };
  };
  closed?: boolean | string;
  configuration?: {
    showDeliveryFeesToEmployee?: boolean;
    completed?: {
      firebase?: boolean;
      stripe?: boolean | string;
    };
    dashboard?: {
      uuid?: boolean;
      contactingButtons?: Array<string>;
      printer?: {
        enabled?: boolean;
        printerUrl?: string;
        type?: string;
      };
      scheduleTimeWindow?: number;
      validateDeliveryFromDashboard?: boolean;
    };
    hubrise?: {
      disableWebhooks?: {
        sendOrder?: boolean;
        updateCatalog?: boolean;
        updateOrder?: boolean;
        updateStock?: boolean;
      };
      accountId?: string;
      accountName?: string;
      catalogId?: string;
      catalogName?: string;
      customerListId?: string;
      customerListName?: string;
      enabled?: boolean;
      locationId?: string;
      locationName?: string;
      show?: boolean;
    };
    oneTouch?: {
      enabled?: boolean;
      ip?: string | boolean;
    };
    orderTypes?: Array<string>;
    sendAcceptOrderEmailCustomer?: boolean;
    sendNewOrderEmail?: boolean;
    paymentTypes?: Array<string>;
    delivery?: {
      freelance?: boolean;
      driverServicePrice?: {
        perKm?: {
          fees?: number | string;
          from?: number;
        };
        steps?: {
          fees?: number;
          km?: number;
        }[];
      };
      userServicePrice?: {
        userServicePriceId?: {
          a0?: {
            fees?: number;
            km?: number;
          };
          fees?: number | string;
          from?: number;
        };
      };
    };
    autoAccept?: {
      enabled?: boolean;
      preparationTime?: number;
    };
    biborne?: {
      enabled?: boolean;
    };
    refs?: {
      charges?: {
        deliveryFeeRef?: {
          key?: string;
          ref?: string;
        };
        managementFeeRef?: {
          key?: string;
          ref?: string;
        };
      };
      orderTypes?: {
        click_and_collect?: {
          key?: string;
          ref?: string;
        };
        delivery?: {
          key?: string;
          ref?: string;
        };
        click_and_seat?: {
          key?: string;
          ref?: string;
        };
      };
      paymentTypes?: {
        stripe?: {
          key?: string;
          ref?: string;
        };
        cash?: {
          key?: string;
          ref?: string;
        };
        cb?: {
          key?: string;
          ref?: string;
        };
        counter?: {
          key?: string;
          ref?: string;
        };
        ticket_resto?: {
          key?: string;
          ref?: string;
        };
      };
    };
    stuart?: {
      enabled?: boolean;
      clientId?: string;
      clientSecret?: string;
    };
    minimum?: number;
    zelty?: {
      enabled?: boolean;
      shopId?: number;
    };
  };
  hours?: {
    Friday?: {
      name?: string;
      slots?: Array<string>;
      limits?: Array<number>;
      limitsDelivery?: Array<number>;
      slotsDelivery?: Array<string>;
      extraProductPrice?: {
        slots?: number;
        values?: {
          price?: number;
          sections?: string;
        }[];
      };
    };
    Monday?: {
      name?: string;
      slots?: Array<string>;
      limits?: Array<number>;
      limitsDelivery?: Array<number>;
      slotsDelivery?: Array<string>;
      extraProductPrice?: {
        slots?: number;
        values?: {
          price?: number;
          sections?: string;
        }[];
      };
    };
    Saturday?: {
      name?: string;
      slots?: Array<string>;
      limits?: Array<number>;
      limitsDelivery?: Array<number>;
      slotsDelivery?: Array<string>;
      extraProductPrice?: {
        slots?: number;
        values?: {
          price?: number;
          sections?: string;
        }[];
      };
    };
    Sunday?: {
      name?: string;
      slots?: Array<string>;
      limits?: Array<number>;
      limitsDelivery?: Array<number>;
      slotsDelivery?: Array<string>;
      extraProductPrice?: {
        slots?: number;
        values?: {
          price?: number;
          sections?: string;
        }[];
      };
    };
    Thursday?: {
      name?: string;
      slots?: Array<string>;
      limits?: Array<number>;
      limitsDelivery?: Array<number>;
      slotsDelivery?: Array<string>;
      extraProductPrice?: {
        slots?: number;
        values?: {
          price?: number;
          sections?: string;
        }[];
      };
    };
    Tuesday?: {
      name?: string;
      slots?: Array<string>;
      limits?: Array<number>;
      limitsDelivery?: Array<number>;
      slotsDelivery?: Array<string>;
      extraProductPrice?: {
        slots?: number;
        values?: {
          price?: number;
          sections?: string;
        }[];
      };
    };
    Wednesday?: {
      name?: string;
      slots?: Array<string>;
      limits?: Array<number>;
      limitsDelivery?: Array<number>;
      slotsDelivery?: Array<string>;
      extraProductPrice?: {
        slots?: number;
        values?: {
          price?: number;
          sections?: string;
        }[];
      };
    };
  };
  legal?: {
    address?: {
      city?: string;
      district?: string;
      id?: string;
      location?: {
        latitude?: number | string;
        latitudeDelta?: number;
        longitude?: number | string;
        longitudeDelta?: number;
      };
      orderType?: string;
      selected?: boolean;
      shopId?: string;
      street?: string;
      street2?: string;
      streetNumber?: string;
      instruction?: string;
      subLocality?: string;
      region?: string;
      country?: string;
      countryCode?: string;
      state?: string;
      postalCode?: string | number;
      zipcode?: string;
      deliveryPrice?: number;
      pricing?: {
        perKm?: {
          fees?: number;
          from?: number;
        };
        steps?: {
          fees?: number;
          km?: number;
        }[];
      };
    };
  };
  managementFee?: number;
  name?: string;
  sections?: {
    [sectionId: string]: {
      description?: string;
      key?: string;
      name?: string;
      position?: number;
      products?: {
        [productId: string]: {
          categories?: string;
          description?: string;
          disabled?: boolean;
          disabledDelivery?: boolean;
          image?: string;
          key?: string;
          name?: string;
          position?: number;
          preparationTime?: string;
          price?: string;
          ref?: string;
          image64?: string;
          stock?: number;
          disabledCC?: boolean;
          disabledCS?: boolean;
          boughtPrice?: number;
          volume?: string;
          hidden?: boolean;
          unit?: string | number;
          imageIds?: Array<string>;
          sectionKey?: string;
          idPicture?: string;
        };
      };
      iconUrl?: string;
      hidden?: boolean;
      ref?: string;
      path?: string;
      image?: string;
    };
  };
  servicePrice?: {
    fees?: {
      contract?: {
        fixe?: number;
        variable?: string | number;
      };
      stripe?: {
        fixe?: number;
        variable?: string;
      };
    };
    last4?: string;
    customAccountId?: string;
  };
  support?: {
    email?: string;
    number?: string;
    fromEmail?: boolean;
  };
  applicationFee?: number;
  cancelFee?: {
    type?: string;
    value?: number | string;
  };
  openCities?: {
    [openCityId: string]: {
      minimum?: number;
      name?: string;
      userServicePrice?: {
        userServicePriceId?: {
          fees?: number;
          priceOrder?: number;
        };
      };
      userCancelServicePrice?: {
        type?: string;
        value?: number | string;
      };
      districts?: {
        [districtId: string]: {
          minimum?: number;
          name?: string;
          userServicePrice?: {
            userServicePriceId?: {
              fees?: number;
              priceOrder?: number;
            };
          };
          districts?: {
            [distric: string]: {
              minimum?: number;
              name?: string;
              userServicePrice?: {
                [userServicePriceId: string]: {
                  fees?: number;
                  priceOrder?: number;
                };
              };
            };
          };
        };
      };
      excludedZones?: {
        [excludedZoneId: string]: {
          name?: string;
          type?: string;
        };
      };
    };
  };
  orderNumber?: number;
  promotions?: {
    [promotionId: string]: {
      count?: number;
      date?: string;
      expired?: boolean;
      isGeneralData?: boolean;
      limit?: number;
      nbAdded?: number;
      nbUsed?: number;
      orderTypes?: Array<string>;
      promoCode?: string;
      promoPath?: string;
      ref?: string;
      shopId?: string;
      type?: string | number;
      canals?: Array<string>;
    };
  };
  startDeliveryService?: string;
  type?: string;
  specialHours?: {
    [hour: string]: {
      day?: string;
      slots?: Array<string>;
    };
  };
  deliveryZones?: {
    [zoneId: string]: {
      color?: string;
      data?: {
        latitude?: number;
        longitude?: number;
        radius?: number;
      };
      key?: string;
      minimum?: number;
      priority?: number;
      shape?: string;
      deliveryFees?: {
        [feeId: string]: {
          fees?: number;
          priceOrder?: number;
        };
      };
    };
  };
  loyalty?: {
    enabled?: boolean;
    limit?: number;
    point?: number;
    type?: string;
  };
  pushNotification?: {
    [pushNotification: string]: {
      cible?: string;
      date?: string;
      message?: string;
      nbUsers?: number;
      title?: string;
    };
  };
  description?: string;
  sliding?: Array<string>;
};

export type Configuration = {
  _id: string;
  admins?: {
    general?: {
      userId?: string;
    };
    distributeur?: {
      userId?: string;
    };
  };
  appName?: string;
  applePay?: boolean;
  merchantId?: string;
  appleStoreId?: boolean | string;
  cgu?: string;
  delivery?: {
    chooseShop?: boolean;
    driverServicePrice?: {
      perKm?: {
        fees?: number;
        from?: number;
      };
      steps?: {
        [stepId: string]: {
          fees?: number;
          km?: number;
        };
      };
    };
    fleetId?: boolean;
    freelance?: boolean;
    paymentTypes?: Array<string>;
    userServicePrice?: {
      perKm?: {
        fees?: number;
        from?: number;
      };
      steps?: {
        [stepId: string]: {
          fees?: number;
          km?: number;
        };
      };
    };
    showOrderInPreparation?: boolean;
    fleet?: {
      hideCancel?: boolean;
      showOrderInPreparation?: boolean;
    };
    mode?: string;
  };
  distributeurId?: string;
  domain?: string;
  featureFlags?: {
    usesBackendV2?: boolean;
  };
  facebook?: {
    auth?: boolean;
    appId?: string;
  };
  fleet?: {
    enabled?: boolean;
  };
  google?: {
    auth?: boolean;
    enabled?: boolean;
    apiKey?: string;
    analytics?: string;
  };
  googlePay?: boolean;
  id?: string;
  images?: {
    aspect?: string;
    myAccount?: string;
    myOrders?: string;
    slides?: Array<string>;
    myLoyalty?: string;
  };
  marketplace?: {
    enabled?: boolean;
  };
  mobileApp?: {
    design?: number;
    enabled?: boolean;
    titleDescription?: string;
    clientSpace?: string;
    newProductsDescription?: string;
  };
  multiOrder?: boolean;
  name?: string;
  orderTypes?: Array<string>;
  paymentTypes?: Array<string>;
  phaseOne?: boolean;
  playStoreId?: boolean | string;
  primaryColor?: string;
  qrcode?: {
    enabled?: boolean;
    paymentTypes?: Array<string>;
  };
  secondaryColor?: string;
  stuart?: boolean;
  style?: string;
  terminal?: {
    easel?: boolean;
    enabled?: boolean;
    paymentTypes?: Array<string>;
  };
  theme?: string;
  url?: string;
  version?: {
    shopId?: {
      option?: boolean;
      product?: boolean;
      order?: boolean;
      orderCompleted?: boolean;
    };
  };
  descriptionText?: string;
  webapp?: {
    chatbot?: boolean;
    descriptionAddress?: string;
    enabled?: boolean;
    hasChatbot?: boolean;
    hasMobileApp?: boolean;
    images?: {
      aspect?: string;
      imageCoverOrderUrl?: string;
    };
    keywords?: string;
    landing?: {
      components?: Array<string>;
      enabled?: boolean;
    };
    landingDesign?: number;
    navbar?: {
      enabled?: boolean;
      homeUrl?: string;
    };
    productStyle?: string;
    sectionOrientation?: string;
    descriptionApp?: string;
    phrases?: {
      cartPhrase?: string;
    };
    slogan?: string;
    hideTitle?: boolean;
  };
  hasIntegration?: boolean;
  servicePrice?: {
    applicationFee?: number;
    customAccountId?: string;
    legal?: {
      address?: {
        city?: string;
        district?: string;
        id?: string;
        location?: {
          latitude?: number | string;
          latitudeDelta?: number;
          longitude?: number | string;
          longitudeDelta?: number;
        };
        orderType?: string;
        selected?: boolean;
        shopId?: string;
        street?: string;
        street2?: string;
        streetNumber?: string;
        instruction?: string;
        subLocality?: string;
        region?: string;
        country?: string;
        countryCode?: string;
        state?: string;
        postalCode?: string | number;
        zipcode?: string;
        deliveryPrice?: number;
        pricing?: {
          perKm?: {
            fees?: number;
            from?: number;
          };
          steps?: {
            fees?: number;
            km?: number;
          }[];
        };
      };
      capitalSocial?: string;
      companyName?: string;
      companyType?: string;
      registreCommerceNumero?: string;
      registreCommerceVille?: string;
    };
    networkFees?: {
      delivery?: {
        fixe?: number;
        productFees?: number;
        variable?: number;
      };
      fixe?: number;
      productFees?: number;
      variable?: number;
    };
    networkId?: boolean;
  };
  activation?: {
    enabled?: boolean;
    message?: string;
    offset?: number;
    title?: string;
  };
  biborne?: {
    enabled?: boolean;
  };
  logoUrl?: string;
  retention?: {
    [retentionId: string]: {
      enabled?: boolean;
      intervalDay?: number;
      maxRetries?: number;
      message?: string;
      minPromo?: number;
      nbCycles?: number;
      offset?: number;
      promoRef?: string;
      title?: string;
    };
  };
  loyalty?: {
    enabled?: boolean;
    limit?: number;
    point?: number;
    type?: string;
    name?: string;
  };
  newProducts?: {
    [productId: string]: {
      categories?: string;
      description?: string;
      disabled?: boolean;
      disabledDelivery?: boolean;
      image?: string;
      key?: string;
      name?: string;
      position?: number;
      preparationTime?: string;
      price?: string;
      ref?: string;
      image64?: string;
      stock?: number;
      disabledCC?: boolean;
      disabledCS?: boolean;
      boughtPrice?: number;
      volume?: string;
      hidden?: boolean;
      unit?: string | number;
      imageIds?: Array<string>;
      sectionKey?: string;
      idPicture?: string;
    };
  };
  hours?: {
    hideScheduledTime?: boolean;
    slotInterval?: number | string;
  };
  socials?: {
    facebook?: string;
    instagram?: string;
    linkedin?: string;
  };
  disableProductInstruction?: boolean;
  cancel?: {
    disabled?: boolean;
  };
  deeplinks?: {
    ddd?: {
      link?: string;
      message?: string;
    };
  };
  hubrise?: {
    enabled?: boolean;
  };
  apple?: {
    auth?: boolean;
  };
};

export type Address = Orders['address'];
export type Order = Orders;

export type ShopState = {
  minimum: number;
  minimumClickAndCollect: number;
  slidingUrls: Shops['sliding'];
  firstOrder: boolean;
} & Partial<{
  userServicePriceInfo: {
    managementFee: Shops['managementFee'];
  };
  addressShop: Address;
  shopConfiguration: Shops['configuration'];
  servicePrice: Shops['servicePrice'];
  categories: Shops['categories'];
  openCities: Shops['openCities'];
  support: Shops['support'];
  openHours: Shops['hours'];
  specialHours: Shops['specialHours'];
  admins: Shops['admins'];
  promotions: Shops['promotions'];
  allowFirstOrderPromo: Shops['allowFirstOrderPromo'];
  shopClosed: Shops['closed'];
  loyalty: Shops['loyalty'];
  shopId: string;
  sections: Shops['sections'];
  name: Shops['name'];
  orders: Order[];
  allShops: {
    [shopId: string]: Shops;
  };
}>;

export interface StylesDictionary {
  [Key: string]: CSSProperties;
}

export type DeliveryInstructions = {
  street2: string;
  instruction: string;
};

export enum MarketingCampaignType {
  BUY_ONE_GET_ONE_PRODUCT = 'buyOneGetOneProduct',
  BUY_ONE_GET_ONE_DIFFERENT_PRODUCT = 'buyOneGetOneDifferentProduct',
  FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD = 'fixedAmountDiscountAfterThreshold',
  FREE_DELIVERY_AFTER_THRESHOLD = 'freeDeliveryAfterThreshold',
  PRODUCT_DISCOUNT_AFTER_THRESHOLD = 'productDiscountAfterThreshold',
  PRODUCT_DISCOUNT = 'productDiscount',
  GLOBAL_PRODUCT_DISCOUNT_AFTER_THRESHOLD = 'globalProductDiscountAfterThreshold',
}

export enum MarketingCampaignDiscountType {
  PERCENTAGE = 'percentage',
  CASH = 'cash',
}

export type MarketingCampaignDiscount = {
  value: number;
  type: MarketingCampaignDiscountType;
};

export type MarketingCampaignConfigProduct = {
  productKey: string;
  productSectionKey: string;
  productOfferedKey?: string;
  productOfferedSectionKey?: string;
};

export type GetOneMarketingCampaignConfig = {
  products: MarketingCampaignConfigProduct[];
  limit?: number;
};

export type ThresholdMarketingCampaignConfig = {
  discount?: MarketingCampaignDiscount;
  products?: MarketingCampaignConfigProduct[];
  threshold: number;
};

export type ProductDiscountMarketingCampaignConfig = {
  discount: MarketingCampaignDiscount;
  products: MarketingCampaignConfigProduct[];
  limit?: number;
};

export type Offer = {
  key: string;
  config:
  | GetOneMarketingCampaignConfig
  | ThresholdMarketingCampaignConfig
  | ProductDiscountMarketingCampaignConfig;
  type: MarketingCampaignType;
  shopIds: string[];
  orderTypes?: string[];
};
